/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import StyledProps from '../theme/AppThemeInterface';

const AppWrapper = styled.div`
  display: block;

  .progress {
    color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
  }

  .app__scrollbar > div {
    overscroll-behavior: none;
  }

  .app__scrollbar--dropdown > div {
    overscroll-behavior: none;
  }

  .track__horizontal {
    display: none !important;
  }

  @media print {
    padding-left: 0;
    padding-top: 0;
  }
`;

export default AppWrapper;
